import styled, { css } from 'styled-components';

import { size } from '../../layout/helpers';
import { rotate } from '../../layout/keyframes';

interface SpinnerProps {
  $color?: string;
  $size?: number;
}

export const Spinner = styled.div<SpinnerProps>`
  position: relative;
  display: block;
  margin: 0 auto;
  width: ${({ $size }) => ($size ? `${$size}px` : size(4))};
  height: ${({ $size }) => ($size ? `${$size}px` : size(4))};
  border-radius: 50%;
  border: ${({ $size }) => ($size ? `${Math.max(2, Math.round($size / 8))}px` : '4px')} solid
    ${(props) => props.$color || props.theme.color.brand.primary.secondary};
  border-top-color: transparent;
  animation: ${rotate} 600ms linear infinite;

  @media (prefers-reduced-motion) {
    animation-duration: 1500ms;
  }
`;

const SpinnerIcon = styled.div<SpinnerProps>`
  position: absolute;
  left: 50%;
  color: currentColor;
  font-size: ${({ $size }) =>
    $size ? `${Math.round($size / 3)}px` : (props) => props.theme.font.size.small};
`;

export const SpinnerIconTop = styled(SpinnerIcon)`
  top: ${({ $size }) => ($size ? `-${Math.round($size / 20)}px` : '-2px')};
  transform: translate(-50%, -50%);
`;

export const SpinnerIconBottom = styled(SpinnerIcon)`
  bottom: ${({ $size }) => ($size ? `-${Math.round($size / 20)}px` : '-2px')};
  transform: translate(-50%, 50%) rotate(180deg);
`;

interface WrapperProps {
  $inline?: boolean;
  $inlineBlock?: boolean;
  $color?: string;
  $size?: number;
}

export const Wrapper = styled.div.attrs(() => ({
  role: 'status',
}))<WrapperProps>`
  color: ${(props) => props.$color || props.theme.color.brand.primary.secondary};

  ${({ $inline, $color, $size }) =>
    $inline &&
    css`
      display: $inline-block;
      vertical-align: middle;
      color: ${$color || 'currentColor'};

      ${Spinner} {
        width: ${$size ? `${$size}px` : '1em'};
        height: ${$size ? `${$size}px` : '1em'};
        border: ${$size ? `${Math.max(2, Math.round($size / 8))}px` : '2px'} solid
          ${$color || 'currentColor'};
        border-top-color: transparent;
      }

      ${SpinnerIconTop},
      ${SpinnerIconBottom} {
        display: none;
      }
    `}

  ${({ $inlineBlock, $color }) =>
    $inlineBlock &&
    css`
      color: ${$color || 'currentColor'};

      ${Spinner} {
        width: 1em;
        height: 1em;
        border: 2px solid ${$color || 'currentColor'};
        border-top-color: transparent;
      }

      ${SpinnerIconTop},
      ${SpinnerIconBottom} {
        display: none;
      }
    `}
`;
